module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "titlepage",
      "id": "bk"
    }
  }, [_c('h1', {
    staticClass: "bk"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "iii",
      "id": "piii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("WRITING for SOCIAL SCIENTISTS")]), _vm._v(" "), _c('h1', {
    staticClass: "bk1"
  }, [_vm._v("How to Start and Finish Your Thesis, Book, or Article")]), _vm._v(" "), _c('h1', {
    staticClass: "bk2"
  }, [_vm._v("THIRD EDITION")]), _vm._v(" "), _c('p', {
    staticClass: "bkau"
  }, [_vm._v("Howard S. Becker")]), _vm._v(" "), _c('p', {
    staticClass: "bkau"
  }, [_c('i', [_vm._v("with a chapter by")]), _vm._v(" PAMELA RICHARDS")]), _vm._v(" "), _c('h1', {
    staticClass: "bk1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/chi-becker-fig00001.jpeg",
      "width": "590"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bkpub"
  }, [_vm._v("The University of Chicago Press")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub1"
  }, [_vm._v("Chicago and London")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-053d3e2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-becker-0004.vue
// module id = 63
// module chunks = 0